export const MARKETWATCH_COLORS = Object.freeze([
  '#89b8e3',
  '#a76cc0',
  '#61c9ae',
  '#f8954a',
  '#67B2CF',
  '#4DB74D',
  '#FD523B',
  '#F6881F',
  '#F9E073',
  '#286E84',
  '#4d4d4d',
  '#919191',
  'rgba(0, 0, 0, 0)',
  '#3677A8',
  '#367F2E',
  '#101010',
]);

const MARKETWATCH_THEME = {
  name: 'MarketWatch',
  theme: [
    MARKETWATCH_COLORS[0],
    MARKETWATCH_COLORS[1],
    MARKETWATCH_COLORS[2],
    MARKETWATCH_COLORS[3],
    MARKETWATCH_COLORS[4],
    MARKETWATCH_COLORS[5],
    MARKETWATCH_COLORS[6],
    MARKETWATCH_COLORS[7],
    MARKETWATCH_COLORS[8],
    MARKETWATCH_COLORS[9],
    MARKETWATCH_COLORS[10],
    MARKETWATCH_COLORS[11],
    MARKETWATCH_COLORS[12],
  ],
};

const MARKETWATCH_BLUE_THEME = {
  name: 'Blue theme',
  theme: [MARKETWATCH_COLORS[13], '#548BB5', '#73A0C2', '#9ABBD3', '#C2D6E5'],
};
const MARKETWATCH_GREEN_THEME = {
  name: 'Green theme',
  theme: [MARKETWATCH_COLORS[14], '#54924D', '#73A66D', '#AFCCAB', '#D7E5D5'],
};
const MARKETWATCH_GRAY_THEME = {
  name: 'Gray theme',
  theme: [MARKETWATCH_COLORS[15], '#585858', '#828282', '#ABABAB', '#D5D5D5'],
};

export const MARKETWATCH_COLOR_THEMES = {
  marketwatch: MARKETWATCH_THEME,
  marketwatch_blue: MARKETWATCH_BLUE_THEME,
  marketwatch_green: MARKETWATCH_GREEN_THEME,
  marketwatch_gray: MARKETWATCH_GRAY_THEME,
};

export const MARKETWATCH_PIE_THEME = Object.freeze([
  ...MARKETWATCH_BLUE_THEME.theme,
  ...MARKETWATCH_GREEN_THEME.theme,
  ...MARKETWATCH_GRAY_THEME.theme,
]);

export const MARKETWATCH_PLOT_LINE_COLORS = Object.freeze([
  MARKETWATCH_COLORS[10],
  MARKETWATCH_COLORS[11],
]);
